import { useMemo } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';

const justModuleAndFeatureRegex = /^\/\w+\/\w+/g;

const useProductReservationRoutes = () => {
    const { path, url } = useRouteMatch();
    const { pathname } = useLocation();

    // Improvement - Redirect if no correct route is passed here
    const matchedPathname = pathname.match(justModuleAndFeatureRegex) || '';

    const routes = useMemo(
        () => ({
            configurationDocumentLink: `${path}/configuration-document-link`,
            configurationPlaceholder: `${path}/configuration-placeholder`,
        }),
        [path],
    );

    return { routes, path, url, matchedPathname };
};

export default useProductReservationRoutes;
